import classNames from 'classnames';
import { Icon, Button } from 'components';
import { useUIState } from 'state';
import styles from './ToggleSideBarButton.module.scss';

/**
 * ToogleSideBarButton
 *
 * @return {JSX.Element}
 */
const ToggleSideBarButton = ({ className, backdrop, icon }) => {
  const uiState = useUIState();
  const handleToggle = () => uiState.toggleSideBar();

  return (
    <Button
      className={classNames(
        styles.ToggleSideBarButton,
        className,
        backdrop &&
          !uiState.isSideBarClosed &&
          styles.ToggleSideBarButton__backdrop,
        `${ToggleSideBarButton.displayName}`
      )}
      onClick={handleToggle}
      reverse
      square
    >
      <Icon name={icon || 'burger'} />
    </Button>
  );
};

ToggleSideBarButton.displayName = 'ToggleSideBarButton';

export default ToggleSideBarButton;
